import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const today = new Date().toISOString().split('T')[0];
const kpiItemBaseClassName = 'card border-none w-100 p-3 d-flex flex-column justify-content-center';

const FrameworkAgreementsKpis = (props) => {

    const context = props.context;
    const frameworkAgreementId = props.frameworkAgreementId;
    const containerType = props.containerType || 'card';
    const readonly = props.readonly || false;
    const showRequestCount = props.showRequestCount || false;

    const [loading, setLoading] = useState(true);
    const [frameworkAgreement, setFrameworkAgreement] = useState(props.frameworkAgreement ?? null);

    const kpisCardRef = useRef(null);
    const [kpisDisplayStartButton, setKpisDisplayStartButton] = useState(false);
    const [kpisDisplayEndButton, setKpisDisplayEndButton] = useState(false);

    const resizeHandler = () => initUi();
    const debounceFunction = (cb, delay) => {
        let timer;
        return () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => cb(), delay);
        };
    };
    const debounce = debounceFunction(resizeHandler, 250);
    useEffect(() => {
        window.addEventListener('resize', debounce);
        return () => window.removeEventListener('resize', debounce);
    }, []);
    
    const { t: gctrad } = useTranslation();

    // TODO À mettre ailleurs ?
    const FRAMEWORK_AGREEMENTS_STATUS_TO_WRITE = 'fa_to_write';
    const FRAMEWORK_AGREEMENTS_STATUS_TO_BE_SIGNED = 'fa_to_be_signed';
    const FRAMEWORK_AGREEMENTS_STATUS_AWAITING_SIGNATURE = 'fa_awaiting_signature';
    const FRAMEWORK_AGREEMENTS_STATUS_SIGNED = 'fa_signed';
    const FRAMEWORK_AGREEMENTS_STATUS_TERMINATED = 'fa_terminated';
    const FRAMEWORK_AGREEMENTS_STATUS_CANCELLED = 'fa_cancelled';
    const FRAMEWORK_AGREEMENTS_VERSIONS_STATUS_DRAFT = 'fav_draft';
    const FRAMEWORK_AGREEMENTS_VERSIONS_STATUS_IN_PROGRESS = 'fav_in_progress';
    const FRAMEWORK_AGREEMENTS_VERSIONS_STATUS_MODIFIED = 'fav_modified';

    // Chargement du contrat
    useEffect(() => {

        if ( 'undefined' != typeof frameworkAgreementId ) {
            let environment = ENV.url.includes('/preview/') ? 'preview' : 'myspace';
            let url = `${ENV.base_lang_url}${environment}/${context}//framework_agreements/ajax_get_one/${frameworkAgreementId}`;
            fetch(url)
                .then(res => res.json())
                .then(result => {
                    setFrameworkAgreement(result.frameworkAgreement);
                    setLoading(false);
                });
        }
        else if ( 'undefined' != typeof frameworkAgreement ) {
            setFrameworkAgreement(frameworkAgreement);
            setLoading(false);
        } // endif

    }, []);

    const initUi = () => {

        setTimeout(() => {

            if (!kpisCardRef.current) return;

            var getWidth = (el, type) => {
                if (type === 'inner') // .innerWidth()
                return el.clientWidth;
                else if (type === 'outer') // .outerWidth()
                return el.offsetWidth;
                let s = window.getComputedStyle(el, null);
                if (type === 'width') // .width()
                return el.clientWidth - parseInt(s.getPropertyValue('padding-left')) - parseInt(s.getPropertyValue('padding-right'));
                else if (type === 'full') // .outerWidth(includeMargins = true)
                return el.offsetWidth + parseInt(s.getPropertyValue('margin-left')) + parseInt(s.getPropertyValue('margin-right'));
                return null;
            } // end of 'getWidth()'

            let kpisCard = kpisCardRef.current;
            let kpisCardParent = kpisCard.parentNode;

            kpisCardParent.addEventListener('scrollend', updateUi);

            kpisCard.style.width = 'initial';

            let kpisCardActualWidth = getWidth(kpisCard, 'outer');

            kpisCard.style.width = 0;

            let kpisContainerWidth = getWidth(kpisCard.closest('.card'), 'inner');

            kpisCard.style.width = `calc(${kpisContainerWidth}px - 2rem)`;

            let widthGap = kpisCardActualWidth - kpisContainerWidth;

            kpisCard.dataset.widthGap = widthGap;

            updateUi();

        }, 250);

    } // end of 'initUi()'

    const updateUi = () => {

        if (!kpisCardRef.current) return;

        let kpisCard = kpisCardRef.current;
        let widthGap = kpisCard.dataset.widthGap;
        let scrollLeft = kpisCard.parentNode.scrollLeft;

        // Bouton de gauche
        setKpisDisplayStartButton(scrollLeft > 15);

        // Bouton de droite
        setKpisDisplayEndButton(scrollLeft < widthGap);

    } // end of 'updateUi()'
    
    const handleClickButton = (type) => {

        if (!kpisCardRef.current) return;

        let kpisCard = kpisCardRef.current;
        let kpisCardParent = kpisCard.parentNode;
        let scrollLeft = kpisCardParent.scrollLeft;

        if ('start' == type) kpisCardParent.scrollLeft = scrollLeft - 200;
        if ('end' == type) kpisCardParent.scrollLeft = scrollLeft + 200;

    } // end of 'handleClickButton()'

    useEffect(() => {
        if ( 'undefined' != typeof frameworkAgreement ) initUi();
    }, [frameworkAgreement]);

    return (
        <>

            {loading ? (
                <></>
            ) : (

                <div className="d-flex justify-content-between w-100" style={{'gap': '1rem'}}>

                    {/* Kpis */}
                    <div className={`d-flex justify-content-between ${showRequestCount ? 'w-75' : 'w-100'}`} style={{'gap': '1rem'}}>

                        {[FRAMEWORK_AGREEMENTS_STATUS_SIGNED, FRAMEWORK_AGREEMENTS_STATUS_TERMINATED].includes(frameworkAgreement.agreement.status)
                            ?
                                <div className={`card border-none w-100 p-3 d-flex flex-row px-3 ${readonly ? 'bg-light' : 'bg-white'}`} style={getKpiItemStyle(frameworkAgreement)}>

                                    {kpisDisplayStartButton && <KpisNavButton position="start" frameworkAgreement={frameworkAgreement} handleClick={() => handleClickButton('start')} />}

                                    <div className="position-relative overflow-hidden d-flex align-items-center">
                                        <a ref={kpisCardRef} href="#" data-part="+" data-target={`${context}//framework_agreements/sales/${frameworkAgreement.agreement.id}`} className={`btn btn-link d-flex flex-row text-decoration-none get_part_link js-nav  ${today > frameworkAgreement.agreement.date_start && !readonly ? '' : 'pe-none'}`} style={{gap: '2rem'}}>
                                            <KpiItem value={new Intl.NumberFormat(ENV.lang.split('_')[0], { style: 'percent' }).format(frameworkAgreement.kpis.time_progression)} label={gctrad('Temps écoulé')} icon="clock" />
                                            <KpiItem value={new Intl.NumberFormat(ENV.lang.split('_')[0], { style: 'percent' }).format(frameworkAgreement.kpis.sales_target_progression)} label={gctrad('Objectif')} icon="chart-simple" />
                                            <KpiItemSeparator />
                                            <KpiItem value={frameworkAgreement.kpis.realised_revenue.formatMoneyK(frameworkAgreement.kpis.sales_target_currency_symbol)} label={`/ ${(frameworkAgreement.kpis.sales_target || 0).formatMoneyK(frameworkAgreement.kpis.sales_target_currency_symbol)}`} icon="bullseye-arrow" />
                                            <KpiItem value={frameworkAgreement.kpis.realised_overnight_stay_count} label={1 < frameworkAgreement.kpis.realised_overnight_stay_count ? gctrad('Nuités') : gctrad('Nuité')} icon="bed-front" />
                                            <KpiItemSeparator />
                                            <KpiItem value={frameworkAgreement.kpis.remaining_night_count} label={1 < frameworkAgreement.kpis.remaining_night_count ? gctrad('Nuits restantes') : gctrad('Nuit restante')} icon="calendar" />
                                        </a>
                                    </div>

                                    {kpisDisplayEndButton && <KpisNavButton position="end" frameworkAgreement={frameworkAgreement} handleClick={() => handleClickButton('end')} />}

                                </div>
                            :
                                <div className={`${kpiItemBaseClassName} bg-transparent`}></div>
                        }

                    </div>

                    {/* Dossiers associés */}
                    {frameworkAgreement?.kpis && showRequestCount &&
                        <div className="d-flex justify-content-between w-25" style={{'gap': '1rem'}}>
                            <a href="#" data-part="+" data-target={`${context}//framework_agreements/sales_requests_hotels/${frameworkAgreement.agreement.id}`} className={`${kpiItemBaseClassName} bg-gc-light-blue-dark text-decoration-none get_part_link js-nav`}>
                                <KpiItem value={frameworkAgreement.kpis.requests_hotels_count} label={1 < frameworkAgreement.kpis.requests_hotels_count ? gctrad('Dossiers') : gctrad('Dossier')} icon="folder" />
                            </a>
                        </div>
                    }

                </div>

            )}

        </>
    );

}

const getKpiItemStyle = frameworkAgreement => {

    let style = {gap: '.25rem', minWidth: '360px', borderLeftWidth: '6px', borderLeftStyle: 'solid', borderLeftColor: 'transparent'};

    if ( today < frameworkAgreement.agreement.date_start ) style.opacity = '0.5';
    else style.borderLeftColor = 0.5 < frameworkAgreement.kpis.overall_progression ? 'var(--success)' : 'var(--danger)';

    return style;

}

const KpiItem = (props) => {

    const {
        label,
        value,
        icon,
    } = props;

    return <div className="d-flex align-items-center justify-content-center text-left" style={{gap: '.5rem'}}>
        <i className={`h4 fa-regular fa-${icon} m-0`}></i>
        <div>
            <span className={`h5 font-weight-bold m-0 mr-1 text-nowrap`}>{value}</span>
            <span className={`d-block small text-nowrap font-weight-normal`} style={{marginTop: '-5px'}}>{label.ucFirst()}</span>
        </div>
    </div>

}

const KpiItemSeparator = (props) => {

    return <div style={{width: '1px', backgroundColor: '#ccc', height: '100% !important'}}>
        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" />
    </div>

}

const KpisNavButton = (props) => {

    const {
        frameworkAgreement,
        position, // start ou end
        handleClick = () => {},
    } = props;

    const btnRef = useRef(null);

    useEffect(() => {
        btnRef.current.addEventListener('click', handleClick);
        return () => {
            btnRef.current?.removeEventListener('click', handleClick);
        };
    }, []);

    let icon;
    let className = 'btn btn-transparent';
    const style = {
        position: 'absolute', 
        zIndex: 1, 
        top: 0, 
        height: '100%', 
        backgroundColor: 'rgba(255,255,255,0.75)',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    }

    switch (position) {

        case 'start':
            icon = 'chevron-left';
            className += ' rounded-0';
            style.left = 0;
        break;

        case 'end':
            icon = 'chevron-right';
            style.right = 0;
        break;

    } // endswitch
    
    return <button
        ref={btnRef}
        id={`${position}-button-${frameworkAgreement.agreement.id}`}
        type="button"
        className={className}
        style={style}>
            <i className={`fa-solid fa-${icon}`}></i>
    </button>

}

export default FrameworkAgreementsKpis;
